















import Vue from 'vue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default Vue.extend({
    name: 'DatetimeFilter',
    components: {
        DatePicker,
    },
    props: {
        /** код для опознания значения в общем массиве фильтров */
        code: {
            type: String,
            required: true,
        },
        /** подпись */
        label: {
            type: String,
            required: false,
            default: 'Фильтр:',
        },
        defaultTimeValue: {
            type: Date,
            required: false,
            default: Date(),

        },
    },
    computed: {},
    methods: {
        inputHandler() {
            const resultObject = { code: this.code, value: this.datetime };
            this.$emit('input', resultObject);
        },
    },
    data() {
        return {
            datetime: null as Date | null,
        };
    }
});
